module.exports = __webpack_public_path__ + "static/media/zepf76.d062b5ea.png";